import type { RoleConfig } from '../types.js';

export const coroner: RoleConfig = {
  id: 'coroner',
  faction: 'town',
  title: { ru: 'Коронер', uk: 'Коронер' },
  latin: 'CORONER',
  number: '35',
  accent: '#a0d8c8',
  ability: {
    ru: 'Ночью изучает игрока — живого или мёртвого — и узнаёт его точную роль.',
    uk: 'Вночі вивчає гравця — живого чи мертвого — і дізнається його точну роль.',
  },
  abilities: [
    {
      key: 'inspect',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: false,
      targetsDeadAllowed: true,
    },
  ],
  victory: { type: 'town' },
};
